import { TweenMax } from 'gsap';
import { Back, Power0 } from 'gsap';

export class HighlightEffect extends PIXI.Sprite {
    private readonly originalScale: number;
    private readonly duration: number;

    constructor({
        texture,
        scale,
        duration,
    }: { texture?: string; scale?: number; duration?: number } = {}) {
        super();
        this.texture = PIXI.utils.TextureCache[texture || 'commonui/opt-in_icon_rays'];
        this.duration = duration || 1;
        this.originalScale = scale || 1;
        this.anchor.set(0.5);
        this.scale.set(this.originalScale);
        this.alpha = 0;
    }

    public appear() {
        this.scale.set(0);
        TweenMax.to(this, this.duration, {
            rotation: 360 * (Math.PI / 180),
            repeat: -1,
            ease: Power0.easeNone,
        });
        TweenMax.to(this, 0.2, { alpha: 1 });
        TweenMax.to(this.scale, 0.5, {
            x: this.originalScale,
            y: this.originalScale,
            ease: Back.easeOut,
        });
    }

    public cleanUp() {
        TweenMax.killTweensOf(this);
        TweenMax.killTweensOf(this.scale);
    }

    public destroy(options?: PIXI.DestroyOptions | boolean): void {
        this.cleanUp();
        super.destroy();
    }
}
